// @flow

import React, { Component } from 'react';
import { connect } from 'react-redux';
import glamorous from 'glamorous';
import t from 'app/utils/translate';
import Loader from 'app/components/commons/Loader';
import { fetchHallOfFame } from 'app/actions/globalLeaderboardActions';
import HallOfFameContentInner from './HallOfFameContentInner';

type Props = {
  competitionId: string,
  competitions: Array<Object>,
  onFetch: (?string) => void,
  isLoading: boolean,
  isSignedIn: boolean,
};

const StyledLoader = glamorous(Loader)(props => ({
  paddingTop: props.theme.spacing.large,
}));

const ComingSoon = glamorous.div(props => ({
  paddingTop: props.theme.spacing.large,
  textAlign: 'center',
  width: '100%',
  fontSize: props.theme.fontSize.default,
  color: props.theme.color.white,
}));

class HallOfFameContent extends Component<Props> {
  props: Props;

  componentDidMount() {
    this.props.onFetch(this.props.competitionId);
  }

  componentDidUpdate(prevProps: Props) {
    const { competitionId, isSignedIn } = this.props;

    if ((isSignedIn && !prevProps.isSignedIn) || competitionId !== prevProps.competitionId) {
      this.props.onFetch(competitionId);
    }
  }

  render() {
    const {
      competitions,
      isLoading,
    } = this.props;

    if (isLoading) {
      return <StyledLoader />;
    }
    if (competitions.length === 0) {
      return (
        <ComingSoon>
          {t('Come back at the end of the season to see the Hall of Fame!')}
        </ComingSoon>
      );
    }

    return (
      <div>
        {competitions.map(comp => (
          <HallOfFameContentInner
            key={comp.id}
            competitionName={comp.name}
            entries={comp.entries}
          />
        ))}
      </div>
    );
  }
}

function mapStateToProps(state: GlobalState) {
  return {
    competitions: state.hallOfFame.competitions,
    isLoading: state.hallOfFame.isLoading,
    isSignedIn: state.user.isSignedIn,
  };
}

const actions = {
  onFetch: fetchHallOfFame,
};

export default connect(mapStateToProps, actions)(HallOfFameContent);
